module.exports = __webpack_public_path__ + "media/images/landing/playstore-3f6fdd3190537a248402abba5e26d054.svg";